import type { UIViewInjectedProps } from '@uirouter/react';
import { observer } from 'mobx-react-lite';

import { api } from '@/api';
import { PERMISSION_OBJ_LOT } from '@/constants/permissions';
import { getAllowedFormFields } from '@/components/generic-form/utils';
import { DrawerForm } from '@/components/drawer-form';
import { waybillStore } from '@/stores';
import { getTranslatedString } from '@/utils';
import { showError } from '@/utils/common';
import { LotSearchSelect } from '@/components/form-fields';

export const AttachLotForm = observer(({ transition }: UIViewInjectedProps) => {
  const { waybillId } = transition.router.globals.params;

  const onClose = () => {
    transition.router.stateService.go('base-layout.waybills');
  };

  const waybill = waybillStore.items.find(({ id }: any) => id === +waybillId) ?? null;

  const formFields = [
    {
      name: 'lotId',
      componentName: 'dropdown',
      component: LotSearchSelect,
      permissionName: PERMISSION_OBJ_LOT,
      params: {
        i18nLabel: 'lots.number',
      },
    },
  ];

  // Field is shown only if user has create permission on lot (attach = adding a lot to waybill).
  const allowedFields = getAllowedFormFields(formFields, true, PERMISSION_OBJ_LOT);

  const resourceController = {
    create: async (values: any) => {
      const wbId = waybillId ? +waybillId : 0;
      const lotId = values.lotId;
      if (!wbId || !lotId) {
        return;
      }
      try {
        const result = await api.waybills.addLots(wbId, [lotId]).source;
        if (result?.data) {
          waybillStore.updateItem(result.data);
        }
      } catch (error) {
        showError(error);
      }
    },
  };

  const initValues = {};
  const title = getTranslatedString('waybill.attachLot.title', {
    0: waybill?.waybillNumber ?? waybillId,
  });

  return (
    <DrawerForm
      title={title}
      initValues={initValues}
      formFields={allowedFields}
      onClose={onClose}
      resourceController={resourceController}
      loaderCondition={false}
    />
  );
});
